// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3lP0d","savePackageButton":"ClientWallet_savePackageButton__2-H7X"};